export default {
  // แถบนำทางด้านข้าง
  navigation: {
    home: 'หน้าแรก',
    gameCenter: 'ศูนย์เกม',
    rechargeCenter: 'ศูนย์เติมเงิน',
    imChat: 'แชท IM',
    consult: 'ข่าวสาร Star',
    starcast: 'แพลตฟอร์มสตรีมมิ่งความบันเทิงแบบกลุ่ม',
  },

  // หน้าแรก
  home: {
    platformFeatures: 'คุณสมบัติแพลตฟอร์ม',
    quickActionsName: 'การดำเนินการด่วน',
    footerText: 'ทำให้การสตรีมง่ายขึ้น และการโต้ตอบสนุกขึ้น',
    features: {
      gameCenter: {
        title: 'ศูนย์เกม',
        description: 'ทรัพยากรเกมที่หลากหลาย รองรับการสตรีมหลายแพลตฟอร์ม',
      },
      imChat: {
        title: 'ข้อความทันที',
        description: 'โต้ตอบแชทแบบเรียลไทม์ เพื่อประสบการณ์ผู้ชมที่ดีขึ้น',
      },
      dataAnalysis: {
        title: 'การวิเคราะห์ข้อมูล',
        description: 'สถิติโดยละเอียด เพื่อเพิ่มประสิทธิภาพการสตรีม',
      },
      efficientStable: {
        title: 'มีประสิทธิภาพและเสถียร',
        description: 'ประสบการณ์สตรีมที่ลื่นไหล พร้อมบริการที่เชื่อถือได้',
      },
    },
    stats: {
      activeUsers: 'ผู้ใช้งานที่ใช้งานอยู่',
      gameResources: 'ทรัพยากรเกม',
      serviceAvailability: 'ความพร้อมให้บริการ',
      technicalSupport: 'การสนับสนุนทางเทคนิค',
    },
    quickActions: {
      gameCenter: 'ศูนย์เกม',
      imChat: 'แชท IM',
      consult: 'ที่ปรึกษา',
    },
  },

  // ศูนย์เกม
  gameCenter: {
    language: 'ภาษาไทย',
    balance: 'ยอดคงเหลือ',
    hotGames: 'เกมยอดนิยม',
    download: 'ดาวน์โหลด',
    update: 'อัปเดต',
    startTikTok: 'เริ่มสตรีม',
    startBigo: 'เริ่มสตรีม',
    document: 'เอกสาร',
    currentGame: 'เกมที่กำลังสตรีม: ',
    currentStatus: 'สถานะการสตรีมปัจจุบัน: ',
    recharge: 'เติมเงิน',
    restart: 'รีสตาร์ทเครื่องมือและเกม',
    closeLive: 'ปิดการสตรีม',
    downloadProgress: 'ความคืบหน้าการดาวน์โหลด: ',
    decompProgress: 'ความคืบหน้าการแตกไฟล์: ',
    waitDecomp: 'กำลังรอแตกไฟล์',
    fixBug: 'แก้ไขบั๊ก',
    clickUpdate: 'คลิกเพื่ออัปเดต',
    downloading: 'กำลังดาวน์โหลด กรุณารอสักครู่~',
    pay: 'กำลังชำระเงิน...',
    xzf: 'ต้องชำระเงิน',
    zs: 'เพชร',
    dest: 'ปลั๊กอินป้องกันการบล็อกเกม Danmu',
    getff: 'ปลดล็อกปลั๊กอิน',
    ffbtun: 'สตรีมป้องกันการตรวจสอบอัตโนมัติ',
    qrkb: 'ยืนยันการสตรีม',
    tkl: 'คุณพร้อมที่จะเริ่มสตรีมป้องกันการตรวจสอบอัตโนมัติหรือยัง?',
    qd: 'ยืนยัน',
    qx: 'ยกเลิก',
  },

  // แชท IM
  imChat: {
    search: 'ค้นหา',
    searchNoResult: 'ไม่พบผู้ใช้',
    tryOtherKeywords: 'กรุณาลองใช้คำค้นหาอื่น',
    noConversations: 'ยังไม่มีประวัติการแชท',
    startChatting: 'ค้นหาผู้ใช้เพื่อเริ่มแชท',
    loadingConversations: 'กำลังโหลดรายการแชท...',
    connecting: 'กำลังเชื่อมต่อเซิร์ฟเวอร์แชท...',
    connectionFailed: '⚠️ การเชื่อมต่อล้มเหลว แชทไม่พร้อมใช้งานชั่วคราว',
    checkNetwork: 'กรุณาตรวจสอบเครือข่ายหรือติดต่อฝ่ายสนับสนุน',
    selectUser: 'กรุณาเลือกผู้ใช้เพื่อเริ่มแชท',
    sending: 'กำลังส่ง...',
    sendMessage: 'ส่ง',
    enterMessage: 'กรุณากรอกข้อความ...',
    noMessages: 'ยังไม่มีข้อความ',
    officialUser: 'XingYu Interactive',
    welcomeChat: 'ยินดีต้อนรับสู่แชท',
    selectConversationHint: 'กรุณาเลือกการสนทนาจากด้านซ้ายเพื่อเริ่มแชท',
    inputDisabledDisconnected:
      'การเชื่อมต่อถูกตัด แชทไม่พร้อมใช้งานชั่วคราว ฟังก์ชันอื่นยังใช้งานได้ตามปกติ กรุณาเข้าสู่ระบบอีกครั้งเพื่อกู้คืนการแชท',
    inputDisabledOfficialNotification: 'การแจ้งเตือนอย่างเป็นทางการเป็นแบบรับอย่างเดียว ไม่สามารถตอบกลับได้',
    RecentSessions: 'เซสชันล่าสุด',
    RecommendedChat: 'เพื่อนทั่วโลก',
    Online: 'ออนไลน์',
    Offline: 'ออฟไลน์',
  },

  // ที่ปรึกษา
  StalConsult: {
    search2: 'ค้นหา',
    all: 'ทั้งหมด',
    Payment: 'ชำระเงิน',
    ViewFullContent: 'ดูเนื้อหาทั้งหมด',
    UnlockFullContent: 'ปลดล็อกเนื้อหาทั้งหมด',
    NeedToPay: 'ต้องชำระเงิน',
    diamond: 'เพชร',
    CurrentBalance: 'ยอดคงเหลือปัจจุบัน',
    Cancel: 'ยกเลิก',
    PayNow: 'ชำระเงินทันที',
    InsufficientBalance: 'ยอดคงเหลือไม่เพียงพอ',
    loading: 'กำลังโหลด...',
    NoMoreContent: 'ไม่มีเนื้อหาเพิ่มเติม',
    return: 'กลับ',
    fd: 'ขยายเพื่อดู',
  },

  // ทั่วไป
  common: {
    confirm: 'ยืนยัน',
    cancel: 'ยกเลิก',
    save: 'บันทึก',
    delete: 'ลบ',
    edit: 'แก้ไข',
    loading: 'กำลังโหลด...',
    success: 'สำเร็จ',
    failed: 'ล้มเหลว',
    error: 'ข้อผิดพลาด',
    warning: 'คำเตือน',
    info: 'ข้อมูล',
  },
}
